import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'story_text',
    props: {
        story : Object
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        content : function(){
            if(!this.story){
                return ''
            }

            return this.story?.content
        },

        footnotes  : function(){
            return this.story?.footnotes || []
        },

        news  : function(){
            return this.story?.news
        },

        vcontent : function(){
            return f.convertNewLinesToBr(f.superXSS(this.content))
        },

        ios : function(){
            return f.isios() && window.cordova
        }
    }),

    methods : {
        close : function(){
            this.$emit('close')
        }
    },
}